import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Card,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Dialog,
} from "@mui/material";
import { t } from "i18next";
import { CATEGORY_CODE } from "../../../constants/enums";

const TargetYearDialog = (props: any) => {
  const {
    open,
    onClose,
    currentTarget,
    year,
    scopewiseData,
    categoriesByYears,
    createKey,
  } = props;

  const cellColumns = ["Target year", "Emissions(tCO2e)", "%SBT reduction"];

  const key = createKey(
    currentTarget.year,
    currentTarget?.scope,
    currentTarget?.categoryId ?? 0
  );

  const scopesForYear = scopewiseData[key]?.scopes || {};
  const sbtValuesForYear = scopewiseData[key]?.sbtValues || {};
  const totalEmissionValue = scopewiseData[key]?.totalEmissionValue || 0;
  const totalSbtVal = scopewiseData[key]?.totalSbtValue || 0;

  console.log(categoriesByYears, "categoriesByYears");
  const renderCategoryRows = () => {
    return categoriesByYears?.get(key).map((eachCategory: any) => (
      <React.Fragment key={eachCategory.id}>
        {eachCategory.code === CATEGORY_CODE.CATEGORY_1_1 && (
          <TableRow>
            <TableCell className="bg-info-100 text-slate-700 text-sm font-bold font-['Proxima Nova'] pt-3 pb-2">
              Scope 1 :
            </TableCell>
            <TableCell className="bg-info-100" align="right">
              {scopesForYear.scope1 || 0}
            </TableCell>
            <TableCell className="bg-info-100" align="right">
              {sbtValuesForYear.sbt1 || 0}
            </TableCell>
          </TableRow>
        )}
        {eachCategory.code === CATEGORY_CODE.CATEGORY_2_1 && (
          <TableRow>
            <TableCell className="bg-info-100 text-slate-700 text-sm font-bold font-['Proxima Nova'] pt-3 pb-2">
              Scope 2 :
            </TableCell>
            <TableCell className="bg-info-100" align="right">
              {scopesForYear.scope2 || 0}
            </TableCell>
            <TableCell className="bg-info-100" align="right">
              {sbtValuesForYear.sbt2 || 0}
            </TableCell>
          </TableRow>
        )}
        {eachCategory.code === CATEGORY_CODE.CATEGORY_3_1 && (
          <TableRow>
            <TableCell className="bg-info-100 text-slate-700 text-sm font-bold font-['Proxima Nova'] pt-3 pb-2">
              Scope 3 :
            </TableCell>
            <TableCell className="bg-info-100" align="right">
              {scopesForYear.scope3 || 0}
            </TableCell>
            <TableCell className="bg-info-100" align="right">
              {sbtValuesForYear.sbt3 || 0}
            </TableCell>
          </TableRow>
        )}
        <TableRow>
          <TableCell
            className={
              !eachCategory.included ? "pw-neutral-background-400" : ""
            }
          >
            {eachCategory.code} {eachCategory.name}
          </TableCell>
          <TableCell
            className={
              !eachCategory.included
                ? "pw-neutral-background-400"
                : `bg-total-row pw-cat-emissionVal-${eachCategory.id} pw-no-focus-outline`
            }
            align="right"
            tabIndex={0}
          >
            {eachCategory.value || 0}
          </TableCell>
          <TableCell
            className={
              !eachCategory.included
                ? "pw-neutral-background-400"
                : `bg-total-row pw-cat-emissionSbt-${eachCategory.id} pw-no-focus-outline`
            }
            align="right"
            tabIndex={0}
          >
            {eachCategory.sbtVal || 0}
          </TableCell>
        </TableRow>
      </React.Fragment>
    ));
  };

  return (
    <Dialog open={open} className="pw-target-dialog">
      <div className="dialog-content">
        <div className="dialog-header">
          <div>Target Year details</div>
          <div onClick={onClose} className="close-icon">
            <CloseIcon />
          </div>
        </div>
        <div className="dialog-body">
          <Card>
            <Table size="small" className="pw-activity-table">
              <TableHead className="pw-activity-table-head">
                <TableRow>
                  {cellColumns.map((eachCell, index) => (
                    <TableCell
                      key={index}
                      className={`pw-activity-list ${
                        index === 0
                          ? "w-[658px]"
                          : index === 1
                          ? " w-[91px] bg-total-row"
                          : index === 2
                          ? "w-[157px] bg-total-row"
                          : " w-[250px]"
                      }`}
                      align={index === 1 ? "center" : "left"}
                    >
                      {t(eachCell)}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell className="bg-info-100">{year || "NA"}</TableCell>
                  <TableCell className="bg-info-100" align="right">
                    {totalEmissionValue}
                  </TableCell>
                  <TableCell className="bg-info-100" align="right">
                    {totalSbtVal}
                  </TableCell>
                </TableRow>
                {renderCategoryRows()}
              </TableBody>
            </Table>
          </Card>
        </div>
      </div>
    </Dialog>
  );
};

export default TargetYearDialog;
